import { MarketingActions } from "../../hooks/useMarketingActions";
import { PageContent } from "../../pages/templates/PageLayout";

import Images from "../images";

const content: PageContent = {
  style: "light",
  sections: [
    {
      type: "HeroSection",
      title: "Apps and Integrations to enhance your workflow",
      style: "light",
      layoutDirection: "vertical",
      subtitle:
        "Work from the web or your desktop and connect Lingo to the tools you alraedy use so you can supercharge your workflow.",
      image: {
        src: Images.Integrations.hero,
        alt: "",
      },
      primaryButton: {
        text: "Try lingo for free",
        link: "/signup",
      },
      secondaryButton: {
        text: "Book a demo",
        action: MarketingActions.BOOK_DEMO,
      },
    },
    {
      type: "MediaSection",
      title: "Web app",
      subtitle: "Manage your assets directly from your browser.",
      image: {
        src: Images.Integrations.web,
        alt: "Launch the Lingo web app",
      },
      primaryButton: {
        text: "Launch web app",
        link: "/space",
        icon: "action.external-link",
      },
    },
    {
      type: "MediaSection",
      title: "Mac app",
      subtitle: "Drag & drop your assets between apps to speed up your workflow.",
      image: {
        src: Images.Integrations.mac,
        alt: "Launch the Lingo web app",
      },
      primaryButton: {
        text: "Download",
        action: MarketingActions.DOWNLOAD_MAC_APP,
        icon: "action.download",
      },
      secondaryButton: {
        text: "Download Beta",
        action: MarketingActions.DOWNLOAD_MAC_APP_BETA,
        icon: "action.download",
      },
    },
    {
      type: "CardSection",
      title: "Integrations",
      // subtitle: "Assets created in Figma can be automatically synced to Lingo.",
      items: [
        {
          title: "Figma",
          body: "Assets created in Figma can be automatically synced to Lingo. ",
          image: {
            src: Images.Integrations.figma,
            alt: "Figma",
          },
          links: [{ text: "Learn more", link: "/integrations/figma" }],
        },
        {
          title: "Sketch",
          body: "Sync all your Sketch assets to Lingo.",
          image: {
            src: Images.Integrations.sketch,
            alt: "Sketch",
          },
          links: [{ text: "Learn more", link: "/integrations/sketch" }],
        },
        {
          title: "Dropbox",
          body: "Import files from dropbox",
          image: {
            src: Images.Integrations.dropbox,
            alt: "Dropbox",
          },
          links: [{ text: "Learn more", link: "/integrations/dropbox" }],
        },
        {
          title: "Google Drive",
          body: "Import files from Google Drive",
          image: {
            src: Images.Integrations.google,
            alt: "Google Drive",
          },
          links: [{ text: "Learn more", link: "/integrations/google" }],
        },
        {
          title: "Lingo API",
          body: "Use the Lingo API to access your content programmatically and build your own digital asset management workflows.",
          image: {
            src: Images.Integrations.api,
            alt: "Lingo API",
          },
          links: [{ text: "Learn more", link: "/integrations/api" }],
        },
      ],
    },
    {
      type: "FaqSection",
      title: "Frequently asked questions",
      faqs: [
        {
          question: "Do I need the Mac app to use Lingo?",
          answer:
            "No, the mac app is an option for mac users but it is not required to use Lingo. With offline storage and drag and drop it provides a convenient way to use your assets.",
        },
        {
          question: "I don't have a Mac, can I still use Lingo?",
          answer:
            "Yes. Anyone on any device can use Lingo in the browser to create, browse and download content.",
        },
      ],
    },
    {
      type: "CtaSection",
    },
  ],
};
export default content;
